import React, { useEffect, useState } from 'react';

import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';

import Page from 'src/components/Page';
import Results from './Results';
import Toolbar from './Toolbar';
import Setting from './Setting';
import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';
import api from '../../services/api'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItems = [
  {
    id: 2,
    code: 'Firmware',
    title: 'Softwares de Dispositivo Homologados',
    items: []
  },
  {
    id: 3,
    code: 'Instrumento',
    title: 'Instrumentos Padrões para Instrumentação',
    items: []
  },
];


const defaultItem = {
  id: null,
  code: '',
  title: '',
  items: []
}

const defaultFilter = {
  text: ''
}

const Settings = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);

  const [state, setState] = useState({
    loaded: false,
    pages: 1,
    page: 1,
    list: []
  })

  const openEdition = (item) => {
    setItem(item);
    setOpenEditionDialog(true);
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({ title: 'Dispositivo', message: 'Deseja excluir o painel de instrumentação selecionado?', warn: 'Esta ação irá interferir na visualização de eventos dos dispositivos.' });
    setOpenDeletionDialog(true);
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateValues = (values) => {
    if (values._id) {
      api.put('/panels1xx/' + values._id, values).then((response) => {
        if (!response.data.error) {
          refreshItems();
          closeEdition();
        }
        setMessage(response.data);
        setOpenAlert(true);
      }).catch((error) => {
        console.error(error);
      })
    } else {
      createValues(values);
    }
  };

  const createValues = (values) => {
    api.post('/panels1xx', values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const deleteValues = (values) => {
    api.delete('/painels1xx/' + values._id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
    })
  };

  const refreshItems = () => {
    //api.get('/panels', { filter: filter }).then((response) => {
    var value = {
      loaded: true,
      pages: 1,
      page: 1,
      list: defaultItems
    }
    setState(value);
    //}).catch((error) => {
    //  console.error(error);
    //})
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  return (
    <Page
      className={classes.root}
      title="Paineis de Instrumentação"
    >
      <Container maxWidth={false}>
        <Toolbar item={defaultItem} openEdition={openEdition} />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Setting item={item}
          openEdition={openEdition}
          closeEdition={closeEdition}
          updateValues={updateValues}
          open={openEditionDialog}
        />

        <Box mt={3}>
          <Results list={state.list}
            openEdition={openEdition}
            openDeletion={openDeletion} />
        </Box>

      </Container>
    </Page>
  );
};

export default Settings;
